import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const faqData = [
    {
        id: 1,
        question: "Why is Mobikode a great place to start or build my career?",
        answer: "At Mobikode, you’ll find a supportive team, exciting projects, continuous learning opportunities, and the freedom to grow your career. "
    },
    {
        id: 2,
        question: "What is the typical Workday like?",
        answer: "A typical day at Mobikode means working with supportive teammates, solving exciting challenges, contributing to meaningful projects, and learning something new in a collaborative and fast-moving environment."
    },
    {
        id: 3,
        question: "What is the work environment like?",
        answer: "At Mobikode, we believe great ideas can come from anyone. We create a supportive and welcoming environment where people are encouraged to collaborate, learn, take initiative, and grow while doing meaningful work together."
    }
];

const FAQSection = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-white">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">
                <div className="flex flex-col lg:flex-row items-start gap-[24px] md:gap-[40px] lg:gap-[80px]">

                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        variants={{
                            lg: { initial: { opacity: 0, x: -30, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
                        }}
                        className="w-full lg:w-5/12 lg:sticky lg:top-[120px]"
                    >
                        <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight leading-[1.2] lg:max-w-[350px]">
                            Your most-asked questions, answered
                        </h2>
                    </motion.div>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        variants={fadeUpVariant}
                        className="w-full lg:w-7/12 flex flex-col border border-[#E4E8F5] bg-white rounded-sm"
                    >
                        {faqData.map((faq, index) => {
                            const isActive = activeIndex === index;

                            return (
                                <div
                                    key={faq.id}
                                    className={`flex flex-col border-b ${isActive ? 'border-[#ED6800] border-b-[3px] md:border-b-[4px]' : 'border-[#E4E8F5]'} last:border-b-0 transition-colors duration-300`}
                                >
                                    <button
                                        onClick={() => toggleAccordion(index)}
                                        className="w-full flex justify-between items-center text-left py-[18px] sm:py-[24px] md:py-[32px] px-[16px] sm:px-[24px] md:px-[40px] group cursor-pointer bg-white md:hover:bg-[#F8FAFF] transition-colors duration-300"
                                    >
                                        <h3 className={`font-sora max-w-[85%] text-[16px] md:text-[20px] font-[600] pr-[16px] sm:pr-[20px] transition-colors duration-300 ${isActive ? 'text-[#01386A]' : 'text-[#01386A] md:group-hover:text-[#ED6800]'}`}>
                                            {faq.question}
                                        </h3>
                                        <div className="flex-shrink-0 text-[#01386A] transition-colors duration-300 md:group-hover:text-[#ED6800]">
                                            {isActive ? (
                                                <svg width="18" height="18" className="md:w-[20px] md:h-[20px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                                </svg>
                                            ) : (
                                                <svg width="18" height="18" className="md:w-[20px] md:h-[20px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                                </svg>
                                            )}
                                        </div>
                                    </button>

                                    <AnimatePresence initial={false}>
                                        {isActive && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.4, ease: "easeInOut" }}
                                                className="overflow-hidden bg-white"
                                            >
                                                <div className="pb-[20px] sm:pb-[32px] px-[16px] sm:px-[24px] md:px-[40px]">
                                                    <p className="font-graphik text-[#6C7689] text-[14px] md:text-[16px] font-[500] leading-[1.6]">
                                                        {faq.answer}
                                                    </p>
                                                </div>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            );
                        })}
                    </motion.div>

                </div>
            </div>
        </section>
    );
};

export default FAQSection;